// src/components/FilterCard/DataArchiveFilterCard.jsx

import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Grid, TextField, Button, Box, Paper, Typography} from '@mui/material';

const DataArchiveFilterCard = ({
  filters,
  setFilters,
  onApply,
  handleDateRangeChange,
  onClear,
  disableDataSource,
}) => {
  // Effect to handle disabling Data Source
  useEffect(() => {
    if (disableDataSource) {
      setFilters((prev) => ({
        ...prev,
        dataSource: '',
      }));
    }
  }, [disableDataSource, setFilters]);

  return (
    <Paper elevation={3} sx={{padding: 2, marginBottom: 2}}>
      <Grid container spacing={2} alignItems='center'>
        {/* Date Range Section */}
        <Grid item xs={12}>
          <Typography variant='h6' gutterBottom>
            Save Date Range
          </Typography>
          <Box sx={{display: 'flex', gap: 2}}>
            <TextField
              label='From Date'
              type='date'
              value={
                filters.dateRange?.[0]
                  ? filters.dateRange[0] instanceof Date
                    ? filters.dateRange[0].toISOString().split('T')[0]
                    : typeof filters.dateRange[0] === 'string' && filters.dateRange[0].includes('T')
                    ? filters.dateRange[0].split('T')[0]
                    : filters.dateRange[0]
                  : ''
              }
              onChange={(e) =>
                handleDateRangeChange([
                  e.target.value,
                  filters.dateRange?.[1] || null,
                ])
              }
              fullWidth
              InputLabelProps={{shrink: true}}
            />
            <TextField
              label='To Date'
              type='date'
              value={
                filters.dateRange?.[1]
                  ? filters.dateRange[1] instanceof Date
                    ? filters.dateRange[1].toISOString().split('T')[0]
                    : typeof filters.dateRange[1] === 'string' && filters.dateRange[1].includes('T')
                    ? filters.dateRange[1].split('T')[0]
                    : filters.dateRange[1]
                  : ''
              }
              onChange={(e) =>
                handleDateRangeChange([
                  filters.dateRange?.[0] || null,
                  e.target.value,
                ])
              }
              fullWidth
              InputLabelProps={{shrink: true}}
            />
          </Box>
        </Grid>

        {/* Action Buttons */}
        <Grid item xs={12}>
          <Box display='flex' justifyContent='flex-end' gap={2}>
            <Button variant='contained' color='primary' onClick={onApply}>
              Apply Filters
            </Button>
            <Button variant='outlined' color='secondary' onClick={onClear}>
              Clear Filters
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

// Corrected PropTypes to reflect actual props
DataArchiveFilterCard.propTypes = {
  filters: PropTypes.shape({
    dropdown1: PropTypes.string,
    dropdown2: PropTypes.string,
    domain: PropTypes.string,
    customer: PropTypes.string,
    dateRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    dataSource: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  handleDateRangeChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  disableDataSource: PropTypes.bool,
};

export default DataArchiveFilterCard;
